import React, { useState, useEffect } from "react";
import axios from "axios";

const Sponsor = () => {
  const [client, setClient] = useState([]);

  useEffect(() => {
    getAllClients();
  }, []);

  const getAllClients = async (e) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER}client`);
      setClient(response.data.clients);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <section
      id="clients"
      className="md:pt-[120px] md:mb-[100px]  py-14 md:py-0"
    >
      <div className="container mx-auto">
        <div
          className="w-full text-slate-800 md:mx-10 px-6 md:px-20  mb-0"
          data-aos="fade-right"
          data-aos-duration="800"
        >
          <h3 className="font-poppins text-3xl md:text-3xl font-medium  border-l-4 border-secondary pl-4 ">
            Klien <span className="text-secondary"> Kami</span>
          </h3>
          <p className="font-poppins font-light text-slate-500 text-sm mt-4">
            Mari bergabung dengan Klien Kami yang terdiri dari
            Instansi/Perusahaan, Kementerian, Corporate, dsb.
          </p>
        </div>

        <div className="w-full">
          <div
            className="flex flex-wrap justify-center items-center gap-4 px-6 md:px-28 mt-6 "
            data-aos="flip-left"
            data-aos-duration="800"
          >
            {client.map((cl) => (
              <div className="w-[21%] md:w-[18%] md:mt-2" key={cl.id}>
                <img src={cl.url} alt="" className="md:w-[50%]" />
              </div>
            ))}
            {/* <div className="w-[21%] md:w-[18%] md:mt-2   ">
              <img src={kalbe} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2   ">
              <img src={indofood} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2   ">
              <img src={komatsu} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2  ">
              <img src={jasamarga} alt="" className="md:w-[50%]" />
            </div>

            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={idClear} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={indomarco} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={pln} alt="" className="md:w-[50%]" />
            </div>

            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={patriot} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={extrupack} alt="" className="md:w-[50%]" />
            </div>

            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={ut} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={astri} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={taruna} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={IDX} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2  ">
              <img src={trisakti} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2  ">
              <img src={ristekdikti} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={gunadarma} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={ubhara} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={master} alt="" className="md:w-[50%]" />
            </div>
            <div className="w-[21%] md:w-[18%] md:mt-2">
              <img src={pertamina} alt="" className="md:w-[50%]" />
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sponsor;
